// extracted by mini-css-extract-plugin
export var merchPromo = "PromotionRule-module--merchPromo--03a06";